// extracted by mini-css-extract-plugin
export default {"card":"GY-z","carouselContainer":"HY-z","carouselContent":"IY-z"};